<template>
    <div class="cases">
        <HeroBlock
            section-title="Agency"
            title="Case Studies"
            content="Partnering with clients from LA to NY"
            imgURL="https://api.uptowncreative.io/uploads/_/originals/810dfd82-38a6-4778-82e0-cb334a1a54c1.jpg"
            :border="false"
        />
        <div class="cases_container">
            <CaseBlock
                v-for="(c, i) in data"
                :key=i
                :title="c.company_name"
                :subtitle="c.subtitle"
                :slug="c.slug"
                :img="c.show_case_image.data.full_url"
             />
        </div>
        <div class="container">
            <SectionTitle title="" class="top-margin-flex"/>
        </div>
        <Sponsors/>
        <AudienceBlock
            class="block bottom-margin zero-top-margin"
            :stat1-number="stats.special_section_stat_1"
            :stat1-title="stats.special_section_stat_title_1"
            :stat2-number="stats.special_section_stat_2"
            :stat2-title="stats.special_section_stat_title_2"
            :stat3-number="stats.special_section_stat_3"
            :stat3-title="stats.special_section_stat_title_3"
        />

    </div>
</template>

<script>
import HeroBlock from '../components/HeroBlock';
import CaseBlock from '../components/CaseBlock';
import AudienceBlock from '../components/AudienceBlock';
import Sponsors from '../components/Sponsors';
import SectionTitle from '../components/SectionTitle';

export default {
    name: "Home",
    components: {
        CaseBlock,
        HeroBlock,
        AudienceBlock,
        Sponsors,
        SectionTitle
    },
    metaInfo: {
        title: 'Case Studies | Uptown Creative ',
        meta: [{
            name: 'description', 
            content: "Case Studies | Uptown Creative "
        }]
    },
    mounted:function(){
        this.axios.get(`https://api.uptowncreative.io/_/items/uptowncreative?fields=company_name,display_show_case,subtitle,slug,show_case_image.*&filter[status][eq]=published&filter[display_show_case][nempty]&sort=cases_sort`)
        .then((response) => {
            if(response.data.data.length > 0){
                this.data = response.data.data
            }
        })
    },
    data(){
        return{
            data: [],
            stats:{
                special_section_stat_1: '100+',
                special_section_stat_title_1: 'Clients & Accounts Serviced',
                special_section_stat_2: '1000+',
                special_section_stat_title_2: 'Projects and Counting',
                special_section_stat_3: '11 Years',
                special_section_stat_title_3: 'Founded in 2009',
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.block{
    margin: 4rem 0;
}
.cases_container{
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    .case:nth-child(odd){
        padding-right: 6.5px;
    }
    .case:nth-child(even){
        padding-left: 6.5px;
    }
}
.bottom-margin{
    margin-bottom: 0;
}
.zero-top-margin{
    margin-top: 0;
}
.top-margin-flex{
    margin-top:43px;
}
@media (max-width: $mobile) { 
    .home-title{
        padding: 2rem 0;
        padding-bottom: 0;
    }
    .cases_container{
        .case:nth-child(odd){
            padding-right: 0px;
        }
        .case:nth-child(even){
            padding-left: 0px;
        }
    }
    .top-margin-flex{
        margin-top: 16px;
    }
}

</style>